import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';
import { userInfoProps } from '@/views/user/personal/typings';

const { riskCheck, getByRefresh } = httpApi.user;

// 新游推荐
export function apiGetByRefresh() {
  return request<userInfoProps>({
    method: 'POST',
    url: getByRefresh
  });
}

// 网易易盾风险检测
interface riskCheckParams {
  wy_token: string;
  scene: string;
}

export function apiRiskCheck(data: riskCheckParams) {
  return request({
    method: 'POST',
    url: riskCheck,
    data
  });
}
